"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { ArrowRight, Facebook, Linkedin, Twitter, Instagram } from "lucide-react";
function NewsletterForm() {
  const {
    handleSubmit,
    control,
    isSubmitting,
    isSubmitted,
    successMessage
  } = useWvcForm();
  if (isSubmitted) {
    return <div className="text-primary-foreground/90 animate-in fade-in slide-in-from-bottom-2">
        <p className="text-sm font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full space-y-2">
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <div className="relative flex items-center">
              <FormControl>
                <Input placeholder="Enter your email" {...field} className="h-10 w-full rounded-none border-0 border-b border-primary-foreground/30 bg-transparent px-0 py-2 text-primary-foreground placeholder:text-primary-foreground/50 focus-visible:border-primary-foreground focus-visible:ring-0 focus-visible:shadow-none" />
              </FormControl>
              <Button type="submit" variant="ghost" size="icon" disabled={isSubmitting} className="absolute right-0 bottom-0 text-primary-foreground hover:bg-transparent hover:text-white disabled:opacity-50">
                <ArrowRight className="size-4" />
                <span className="sr-only">Subscribe</span>
              </Button>
            </div>
            <FormMessage className="text-red-300" />
          </FormItem>} />
    </Form>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const services = ["Lifelong Learning Growth Strategy", "Learner Experience & Retention Design", "Leadership & Organizational Capability Development"];
  const companyLinks = [{
    title: "About Us",
    href: "/AboutUsPage"
  }, {
    title: "How We Work",
    href: "/HowWeWorkPage"
  }, {
    title: "Impact Stories",
    href: "/ImpactStoriesPage"
  }, {
    title: "Services",
    href: "/ServicesPage"
  }];
  return <footer id="footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 mb-16">
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block">
              <img src="https://edustrategygroup.com/wp-content/uploads/2026/03/819ae0d6-38e6-4d37-b7ea-19ec945afd5e-1.png" alt="EduStrategy Group" className="h-28 w-auto object-contain !bg-[hsl(213,27%,84%)] !opacity-[1]" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed max-w-xs">
              Growth You Own
            </p>
            <div className="flex gap-4 pt-2">
              <Link to="https://www.linkedin.com/company/edustrategygroup" newTab className="text-primary-foreground/70 hover:text-white transition-colors">
                <Linkedin className="size-5" />
                <span className="sr-only">LinkedIn</span>
              </Link>
              <Link to="#" className="text-primary-foreground/70 hover:text-white transition-colors">
                <Twitter className="size-5" />
                <span className="sr-only">Twitter</span>
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-serif font-medium tracking-wide">Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="https://edustrategygroup.com/services" className="text-sm text-primary-foreground/70 hover:text-white transition-colors block leading-snug">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-serif font-medium tracking-wide">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-primary-foreground/70 hover:text-white transition-colors">
                    {link.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-serif font-medium tracking-wide">Stay Connected</h3>
            <p className="text-sm text-primary-foreground/70">
              Join our network of mission-driven leaders.
            </p>
            <FormProvider formId="newsletter-footer" sectionName="footer" defaultValues={{
            email: ""
          }} successMessage="Thank you for subscribing!" className="w-full">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="bg-primary-foreground/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-primary-foreground/60">
          <div className="flex flex-col md:flex-row gap-4 md:gap-8 items-center">
            <p>&copy; {currentYear} EduStrategy Group, LLC</p>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>

          <Link to="https://edustrategygroup.com/schedule-your-strategy-session/" className="group flex items-center gap-2 text-white font-medium hover:text-secondary-foreground transition-colors">
            <span>Start a Conversation</span>
            <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </footer>;
}